export default __webpack_public_path__ + "static/media/mascot-murder-mystery.51bf2f0c.gif";